module.exports = __webpack_public_path__ + "assets/img/patient-desc-icon.e1b1e925.png";